import React from 'react';

import icon_deu_buecher from './Images/icon-deu-buecher-grau.svg';
import icon_engl_buecher from './Images/icon-engl-buecher-grau.svg';
import icon_filme from './Images/icon-filme-grau.svg';
import icon_kinderbuecher from './Images/icon-kinderbuecher-grau.svg';
import icon_musik from './Images/icon-musik-grau.svg';
import icon_noten from './Images/icon-noten-grau.svg';
import icon_schreibwaren from './Images/icon-schreibwaren-grau.svg';
import icon_spiele from './Images/icon-spiele-grau.svg';

import './SolrData.scss';
import MolLink from '../../Basepage/parts/Menu/MolLink';

export interface SolrDataItem {
  historic_data_id: string;
  value: number;
}
interface SolrDataProps {
  data: SolrDataItem[];
}

export default class SolrData extends React.Component<SolrDataProps> {
  render(): React.ReactNode {
    let elements: {
      img: string;
      url: string;
      urlIntern: string;
      text: string;
      value: number;
    }[] = [];
    let data = this.props.data??[];
    for (let index = 0; index < data.length; index++) {
      let img = null;
      let url = '';
      let urlIntern = '';
      let text = '';
      switch (data[index].historic_data_id) {
        case '649': //Buchbutler - Solr - deutsche Bücher (Kategorie = Buch + Sprache = deutsch)
          img = icon_deu_buecher;
          url = '/Kategorie/buch/Sprache/deutsch/s/';
          urlIntern = '/search_page/?fqZZZKategorie=buch&fqZZZSprache=deutsch';
          text = 'deutsche Bücher';
          break;
        case '650': //Buchbutler - Solr - englische Bücher (Kategorie = Buch + Sprache = englisch)
          img = icon_engl_buecher;
          url = '/Kategorie/buch/Sprache/englisch/s/';
          urlIntern = '/search_page/?fqZZZKategorie=buch&fqZZZSprache=englisch';
          text = 'englische Bücher';
          break;
        case '651': //Buchbutler - Solr - Kinderbücher (Kategorie = Buch + Hauptwarengruppe = kinderbuch und jugendbuch)
          img = icon_kinderbuecher;
          url =
            '/Hauptwarengruppe/kinderbuch%20und%20jugendbuch/Kategorie/buch/s/';
          urlIntern =
            '/search_page/?fqZZZHauptwarengruppe=kinderbuch%20und%20jugendbuch&fqZZZKategorie=buch';
          text = 'Kinderbücher';
          break;
        case '652': //Buchbutler - Solr - Noten (Kategorie = Noten)
          img = icon_noten;
          url = '/Kategorie/noten/s/';
          urlIntern = '/search_page/?fqZZZKategorie=noten';
          text = 'Noten';
          break;
        case '653': //Buchbutler - Solr - Musik Artikel (Kategorie = Musik)
          img = icon_musik;
          url = '/Kategorie/musik/s/';
          urlIntern = '/search_page/?fqZZZKategorie=musik';
          text = 'Musik Artikel';
          break;
        case '654': //Buchbutler - Solr - Filme (Kategorie = Film)
          img = icon_filme;
          url = '/Kategorie/film/s/';
          urlIntern = '/search_page/?fqZZZKategorie=film';
          text = 'Filme';
          break;
        case '655': //Buchbutler - Solr - Spiele + Spielzeug (Kategorie = Spielware)
          img = icon_spiele;
          url = '/Kategorie/spielware/s/';
          urlIntern = '/search_page/?fqZZZKategorie=spielware';
          text = 'Spiele';
          break;
        case '656': //Buchbutler - Solr - Schreibwaren  (Kategorie = Schreibwaren)
          img = icon_schreibwaren;
          url = '/Kategorie/schreibwaren/s/';
          urlIntern = '/search_page/?fqZZZKategorie=schreibwaren';
          text = 'Schreibwaren';
          break;
      }

      if (img != null)
        elements.push({
          img: img,
          url: url,
          urlIntern: urlIntern,
          text: text,
          value: data[index].value,
        });
    }

    return (
      <div id="SolrData">
        {elements.map((e_item, e_nindex) => {
          let key = 'SolrData_1_' + (e_nindex + 1);
          return (
            <div
              style={{ gridRow: 1, gridColumn: e_nindex + 1 }}
              id={key}
              key={key}
              className="solrImage"
            >
              <MolLink to={e_item.urlIntern} href={e_item.url}>
                <img className="solrImage" src={e_item.img} />
              </MolLink>
            </div>
          );
        })}

        {elements.map((e_item, e_nindex) => {
          let key = 'SolrData_2_' + (e_nindex + 1);
          return (
            <div
              style={{ gridRow: 2, gridColumn: e_nindex + 1 }}
              id={key}
              key={key}
              className="solrName"
            >
              <MolLink to={e_item.urlIntern} href={e_item.url}>
                {e_item.text}
              </MolLink>
            </div>
          );
        })}

        {elements.map((e_item, e_nindex) => {
          let key = 'SolrData_3_' + (e_nindex + 1);
          return (
            <div
              style={{ gridRow: 3, gridColumn: e_nindex + 1 }}
              id={key}
              key={key}
            >
              <MolLink to={e_item.urlIntern} href={e_item.url}>
                {new Intl.NumberFormat('de-DE').format(e_item.value)}
              </MolLink>
            </div>
          );
        })}
      </div>
    );
  }
}
